import { global } from 'styled-jsx/css';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { ClassNameMap, Styles, WithStylesOptions } from '@material-ui/core/styles/withStyles';
import muiMakeStyles from '@material-ui/core/styles/makeStyles';
import { useTheme as MuiUseTheme } from '@material-ui/core/styles';
import { ScaleAITheme } from './theme';

type StylesHook<P extends {} = {}, C extends string = string> = (props?: P) => ClassNameMap<C>;

export const useTheme = () => MuiUseTheme<ScaleAITheme>();

export function makeStyles<Props extends {} = {}, ClassKey extends string = string>(
  styles: Styles<ScaleAITheme, Props, ClassKey>,
  options?: Omit<WithStylesOptions<ScaleAITheme>, 'withTheme'>,
) {
  return muiMakeStyles<ScaleAITheme, Props, ClassKey>(styles, options) as StylesHook<
    Props,
    ClassKey
  >;
}

export const sAlert = global`
  .s-alert-wrapper > div {
    z-index: 100001;
  }

  .s-alert-box {
    font-family: var(--font-family) !important;
    font-size: 14px !important;
    border-radius: 8px;
    padding: 16px 24px 16px 16px;
    box-shadow: var(--box-shadow);
  }

  .s-alert-close {
    width: 20px !important;
    height: 20px !important;
    border-radius: 100% !important;
    background-color: rgba(255, 255, 255, 0.4) !important;
    transition: all 0.3s;
  }

  .s-alert-close:hover {
    background-color: rgba(255, 255, 255, 0.6) !important;
  }

  .s-alert-close:before,
  .s-alert-close:after {
    height: 10px !important;
    width: 1px !important;
  }

  .s-alert-info {
    background: #fff !important;
    color: var(--color-RemoGray75) !important;
    border: none !important;
  }

  .s-alert-info .s-alert-close {
    background-color: var(--color-RemoGray01) !important;
  }

  .s-alert-info .s-alert-close:before,
  .s-alert-info .s-alert-close:after {
    background: var(--color-RemoGray75) !important;
  }

  .s-alert-success {
    background: #e1ffbf !important;
    color: #34570e !important;
  }

  .s-alert-success .s-alert-close:before,
  .s-alert-success .s-alert-close:after {
    background: #34570e !important;
  }

  .s-alert-warning {
    background-color: #fffcd6 !important;
    color: #926f00 !important;
  }

  .s-alert-warning .s-alert-close:before,
  .s-alert-warning .s-alert-close:after {
    background: #926f00 !important;
  }

  .s-alert-error {
    background: #ffcebe !important;
    color: #7a3019 !important;
  }

  .s-alert-error .s-alert-close:before,
  .s-alert-error .s-alert-close:after {
    background: #7a3019 !important;
  }
`;
